// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { DivisasProvider } from './contexts/DivisasContext';
import Home from './pages/public/Home';
import Servicios from './pages/public/Servicios';
import Compra from './pages/public/Compra';
import CompraPrueba from './pages/public/CompraPrueba';
import BuscarReserva from './pages/public/BuscarReserva';
import AdminLogin from './pages/admin/Login';
import Dashboard from './pages/admin/Dashboard';
import ServiciosAdmin from './pages/admin/ServiciosAdmin';
import ReservasAdmin from './pages/admin/ReservasAdmin';
import VentaDirecta from './pages/admin/VentaDirecta';
import ItinerarioAdmin from './pages/admin/ItinerarioAdmin';
import ConfiguracionAdmin from './pages/admin/ConfiguracionAdmin';
import SonnerProvider from './components/SonnerProvider';
import './App.css';

const ProtectedRoute = ({ children }) => {
  const { admin } = useAuth();
  if (!admin) return <Navigate to="/admin/login" replace />;
  return children;
};

function AppRoutes() {
  const { admin, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center"><div className="text-gray-500">Cargando...</div></div>;

  return (
    <>
      <SonnerProvider />
      <Routes>
        {/* Rutas públicas */}
        <Route path="/" element={<Home />} />
        <Route path="/servicios" element={<Servicios />} />
        <Route path="/compra" element={<Compra />} />
        <Route path="/test-pdf" element={<CompraPrueba />} />
        <Route path="/buscar-reserva" element={<BuscarReserva />} />
        
        {/* Rutas admin */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        } />
        <Route path="/admin/servicios" element={
          <ProtectedRoute>
            <ServiciosAdmin />
          </ProtectedRoute>
        } />
        <Route path="/admin/reservas" element={
          <ProtectedRoute>
            <ReservasAdmin />
          </ProtectedRoute>
        } />
        <Route path="/admin/venta-directa" element={
          <ProtectedRoute>
            <VentaDirecta />
          </ProtectedRoute>
        } />
        <Route path="/admin/itinerario" element={
          <ProtectedRoute>
            <ItinerarioAdmin />
          </ProtectedRoute>
        } />
        <Route path="/admin/configuracion" element={
          <ProtectedRoute>
            <ConfiguracionAdmin />
          </ProtectedRoute>
        } />
        
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <Router>
      <DivisasProvider>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </DivisasProvider>
    </Router>
  );
}

export default App;